<template>
    <div class="panel">
        <div class="panel-heading">
            <div class="panel-title">
                <div class="accordion-toggle collapsed" :href="'#collapse_' + parent + '_' + info.hash" data-toggle="collapse">
                    <div class="papka-bkg">{{ info.name }}</div>
                </div>
            </div>
        </div>
        <div :id="'collapse_' + parent + '_' + info.hash" class="panel-collapse collapse" style="height: 0px;width: 95%">
            <div class="panel-body">
                <FolderV2 v-bind:key="item.id" v-for="item in info.folders" :info="item" :parent="parent + '_' + info.hash"  />
                <ul v-if="info.files"  class="kris-doclist ekis" style="width: inherit;" >
                    <FileV2 v-bind:key="item.hash" v-for="item in info.files" :info="item" />
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import FileV2 from './FileV2'

    export default {
        name: "FolderV2",
        components: {FileV2},

        data(){
            return {}
        },

        props:[
            "info",
            "parent"
        ],
    }
</script>

<style scoped>

</style>
